"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionMarkBlueImage = exports.questionImage = exports.tablesImage = exports.toolboxImage = exports.pencilImage = exports.foldersImage = void 0;
// biome-ignore lint: -
exports.foldersImage = require("../../../../assets/images/menu-icons/folders.png");
// biome-ignore lint: -
exports.pencilImage = require("../../../../assets/images/menu-icons/equalizer-pencil.png");
// biome-ignore lint: -
exports.toolboxImage = require("../../../../assets/images/menu-icons/toolbox.png");
// biome-ignore lint: -
exports.tablesImage = require("../../../../assets/images/menu-icons/tables.png");
// biome-ignore lint: -
exports.questionImage = require("../../../../assets/images/menu-icons/question.png");
// biome-ignore lint: -
exports.questionMarkBlueImage = require("../../../../assets/images/question-mark-blue-circle.svg");
//# sourceMappingURL=menu-icons.js.map